export const DEFAULT_PAGE_TEMPLATE_KEY = 'default' as const

export type DefaultPageTemplateKey = typeof DEFAULT_PAGE_TEMPLATE_KEY

export const FIXED_PAGE_TEMPLATE_KEYS = [
  'home',
  'aboutUs',
  'booking',
  'bookStarterPackages',
  'mobileApp',
  'carParking',
  'contact',
  'parents',
  'whyInNeonWood',
  'sustainableLiving',
  'apartments',
  'posts',
  'promotions',
  'partners',
  'events',
] as const

export type FixedPageTemplateKey = (typeof FIXED_PAGE_TEMPLATE_KEYS)[number]

export type PageTemplateKey = DefaultPageTemplateKey | FixedPageTemplateKey

export type TemplatePathMap = Record<FixedPageTemplateKey, string>

export const ARCHIVE_TEMPLATE_KEYS = ['posts', 'promotions', 'events'] as const

export type ArchiveTemplateKey = (typeof ARCHIVE_TEMPLATE_KEYS)[number]

export const DETAIL_ARCHIVE_TEMPLATE_KEYS = ['posts', 'promotions'] as const

export type DetailArchiveTemplateKey = (typeof DETAIL_ARCHIVE_TEMPLATE_KEYS)[number]

export const PAGE_TEMPLATE_OPTIONS: ReadonlyArray<{
  label: string
  value: PageTemplateKey
}> = [
  { label: 'Default Page', value: 'default' },
  { label: 'Home', value: 'home' },
  { label: 'About Us', value: 'aboutUs' },
  { label: 'Booking', value: 'booking' },
  { label: 'Starter Packages', value: 'bookStarterPackages' },
  { label: 'Mobile App', value: 'mobileApp' },
  { label: 'Car Parking', value: 'carParking' },
  { label: 'Contact', value: 'contact' },
  { label: 'Parents', value: 'parents' },
  { label: 'Why in Neon Wood', value: 'whyInNeonWood' },
  { label: 'Sustainable Living', value: 'sustainableLiving' },
  { label: 'Apartments', value: 'apartments' },
  { label: 'Posts Archive', value: 'posts' },
  { label: 'Promotions Archive', value: 'promotions' },
  { label: 'Partners', value: 'partners' },
  { label: 'Events Archive', value: 'events' },
]

export const SINGLETON_TEMPLATE_KEYS: ReadonlySet<FixedPageTemplateKey> = new Set(
  FIXED_PAGE_TEMPLATE_KEYS,
)

export function isPageTemplateKey(value: unknown): value is PageTemplateKey {
  return PAGE_TEMPLATE_OPTIONS.some((option) => option.value === value)
}

export function isFixedPageTemplateKey(value: unknown): value is FixedPageTemplateKey {
  return typeof value === 'string' && SINGLETON_TEMPLATE_KEYS.has(value as FixedPageTemplateKey)
}

export function isArchiveTemplateKey(value: unknown): value is ArchiveTemplateKey {
  return ARCHIVE_TEMPLATE_KEYS.includes(value as ArchiveTemplateKey)
}

export function isDetailArchiveTemplateKey(value: unknown): value is DetailArchiveTemplateKey {
  return DETAIL_ARCHIVE_TEMPLATE_KEYS.includes(value as DetailArchiveTemplateKey)
}

export function normalizePageTemplateKey(value: unknown): PageTemplateKey {
  return isPageTemplateKey(value) ? value : DEFAULT_PAGE_TEMPLATE_KEY
}
